export default {
    platformInfo: undefined,
    platformUrl: '',
    pfCanGoback: true
}